import { render, staticRenderFns } from "./PlexSeries.vue?vue&type=template&id=57432663&"
import script from "./PlexSeries.vue?vue&type=script&lang=js&"
export * from "./PlexSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports